import React from "react"

const Stackoverflow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24.393"
    viewBox="0 0 20 24.393"
  >
    <g
      id="stackoverflow"
      data-name="stackoverflow"
      transform="translate(-448.484 -269.161)"
    >
      <path
        id="Path_7236"
        data-name="Path 7236"
        d="M467.484,284.354v8.2h-18v-8.2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        id="Path_7237"
        data-name="Path 7237"
        d="M453.389,289.048h9.952"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        id="Path_7238"
        data-name="Path 7238"
        d="M453.345,284.239l10.24,2.178"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="3.999"
        strokeWidth="2"
      />
      <path
        id="Path_7239"
        data-name="Path 7239"
        d="M454.213,278.846l9.329,4.753"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        id="Path_7240"
        data-name="Path 7240"
        d="M456.772,274.432l8.138,6.589"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        id="Path_7241"
        data-name="Path 7241"
        d="M460.71,270.554l6.011,8.575"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </g>
  </svg>
)

export default Stackoverflow
